import { Loader2 } from 'lucide-react'

import { useBusinessCreateContext } from 'src/features/business-create/context/business-create-context'
import { Button } from 'src/shared/components/ui/buttons/button'
import { cn } from 'src/shared/utils/cn'

interface BCFooterProps {
  showBackButton?: boolean
  buttonText?: string
  buttonVariant?: 'default' | 'ghost'
  isLoading?: boolean
  primaryAction?: () => void
  secondaryButton?: {
    text: string
    onClick: () => void
  }
}

const BCFooter = ({
  showBackButton = true,
  buttonText = 'Continue',
  buttonVariant = 'default',
  isLoading = false,
  primaryAction,
  secondaryButton,
}: BCFooterProps) => {
  const { handleBack } = useBusinessCreateContext()

  return (
    <div className="absolute inset-x-0 bottom-0 flex h-[100px] w-full flex-row items-center justify-between rounded-b-[20px] border-t border-lightBorder bg-white p-5">
      {showBackButton ? (
        <Button variant="link" className="no-underline" size="default" onClick={handleBack}>
          Go back
        </Button>
      ) : (
        <div> {/* empty div, dont remove, used for spacing */} </div>
      )}
      <div className="flex flex-row items-center gap-4">
        {secondaryButton ? (
          <Button variant="link" size="default" className="no-underline" onClick={secondaryButton.onClick}>
            {secondaryButton.text}
          </Button>
        ) : null}
        <Button
          variant={buttonVariant}
          size="xl"
          className={cn(
            'w-[250px] rounded-full text-base font-semibold',
            buttonVariant === 'ghost' && 'border border-primary',
          )}
          form={primaryAction ? undefined : 'business-create-form'}
          type={primaryAction ? 'button' : 'submit'}
          onClick={primaryAction}
          disabled={isLoading}
        >
          {isLoading ? <Loader2 className="size-4 animate-spin" /> : buttonText}
        </Button>
      </div>
    </div>
  )
}

export default BCFooter
